import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'expCalcPipe',
    pure: true
})
export class ExpCalcPipe implements PipeTransform {

    transform(date1, date2, format = 'y'): any {
        let miliseconds = Math.abs(date2 - date1);
        let days, hours, minutes, seconds, total_hours, total_minutes, total_seconds, years;

        total_seconds = Math.floor(miliseconds / 1000);
        total_minutes = Math.floor(total_seconds / 60);
        total_hours = Math.floor(total_minutes / 60);
        days = Math.floor(total_hours / 24);
        years = Number(days / 365).toFixed(1);
        seconds = total_seconds % 60;
        minutes = total_minutes % 60;
        hours = total_hours % 24;
        switch (format) {
            case 's':
                return total_seconds;
            case 'm':
                return total_minutes;
            case 'h':
                return total_hours;
            case 'd':
                return days;
            case 'y':
                return Number(years);
            default:
                return { d: days, h: hours, m: minutes, s: seconds };
        }
    }
}